import React, { useState, useEffect } from "react";
import "./AgeModal.css";
import { RxCross1 } from "react-icons/rx";
import calculateAge from "./AgeModalHelper";
import { UpdatePlanAgeApi } from "../../redux/Slice";
import axios from "axios";
import { encryption } from "../../helper/common";
import { useNavigate } from "react-router-dom";
import ProposalPop from "../../commonComponents/ProposalPop";
import { useDispatch } from "react-redux";
import Loader from "../../../AllPageComponents/Loader";
import Swal from "sweetalert2";

import { updateQuickQuoteCompanywise } from "../../Api/Api";
import { settingReduxData, updateQuickQuote } from "../../Api/Api";

const AgeModal = ({
  isOpen,
  showModal,
  setShowModal,
  ageDifference,
  ageSame,
  setProposalCorrect,
  setProposerCorrect,
  apiResponse,
  setApiResponse,
  proposerData,
  socketManager,
  apidata,
  calculateAge,
  setProposerData,
  previousPremium,
}) => {
  const [isActive, setIsActive] = useState(true);

  const [isClosing, setIsClosing] = useState(false);
  const [newPremium, setNewPremium] = useState("");
  const [newUserData, setNewUserData] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [responseData, setResponseData] = useState("");
  const [stopLoading, setStopLoading] = useState(false);
  const [showPop, setShowPop] = useState(false);

  const [appear, setAppear] = useState(false);

  const search = window.location.search;
  const params = new URLSearchParams(search);
  const unique_id = params.get("req_id");
  const plan_id = params.get("plan_id");
  const c_id = params.get("c_id");

  const nav = useNavigate();
  const updateAllInsuredAges = (insuredDetails, newAges) => {
    let updatedInsuredDetails = [];

    let insuredArr = insuredDetails;
    insuredArr.forEach((insured, index) => {
      let ageChangeFound = false;
      for (var i = 0; i < newAges.length; i++) {
        let newAgeItem = newAges[i];

        if (newAgeItem.index == index) {
          ageChangeFound = true;

          if (insured.InsuredAge !== newAgeItem.newAge) {
            updatedInsuredDetails.push({
              ...insured,
              InsuredAge: newAgeItem.newAge,
            });
          } else {
            updatedInsuredDetails.push(insured);
          }
        }

        if (ageChangeFound) break;
      }
      if (!ageChangeFound) {
        updatedInsuredDetails.push(insured);
      }
    });

    return updatedInsuredDetails;
  };

  const premiumChange = (companyName, planCode) => {
    setIsLoading(true);

    let data = socketManager.isConnected();

    // if (!data) {
    //   socketManager.connect(unique_id, (res) => {

    //   });
    // }

    // let checkConnect = socketManager.isConnected();

    if (data) {
      const storedInsuredDetail = proposerData.InsuredDetail;
      let parsedInsuredDetail = null;

      let updatedInsuredDetails = updateAllInsuredAges(
        storedInsuredDetail,
        ageDifference
      );

      const updatedUserdata = {
        ...proposerData,
        CompanyName: c_id,
        PlanCode: plan_id,
        InsuredDetail: updatedInsuredDetails,
        State: "West Bengal",
        sum_insured: apiResponse?.request?.sum_insured,
        addons: apiResponse?.request?.addons || "",
        addonPrice: apiResponse?.request?.addonPrice || "",
        // addonPrice: "" ,
        tenure: apiResponse.request.tenure,
        PED: JSON.parse(localStorage.getItem("PED")),
        voluntarydeductiblelimit:
          apiResponse.request.voluntarydeductiblelimit || null,
        roomrent_type: apiResponse.request.roomrent_type || null,
        cdb_limit: apiResponse.request.cdb_limit || null,
        ped_waiting_period: apiResponse.request.ped_waiting_period || null,
        reductioninwaitingperiodlimit:
          apiResponse.request.reductioninwaitingperiodlimit || null,
        opd_sum_insured: apiResponse.request.opd_sum_insured || null,
        opd_plan: apiResponse.request.opd_plan || null,
        super_charger_option: apiResponse.request.super_charger_option || null,
        NetworkAdvantageApplicable: "no",
        HDCRiderSI: apiResponse?.request?.HDCRiderSI || 0,
        deductible: apiResponse?.request?.deductible || 0,
      };

      updateQuickQuoteCompanywise(updatedUserdata, unique_id).then((data) => {
        if (data) {
          setApiResponse((prevData) => ({
            ...prevData,
            request: apiResponse.request,
          }));
        }
      });
    } else {
      setIsLoading(false);
      return;
    }
  };

  const settingData = async (value) => {
    try {
      let phNo = localStorage.getItem("Proposalphonenumber");

      let payloadData = {
        proposal_data: value,
        phone_no: proposerData?.Proposalphonenumber,
      };

      let response = await settingReduxData(unique_id, payloadData).then();
    } catch (error) {
      console.log("the error", error);
    }
  };

  const submitAccept = async () => {
    let newInsuredDetail = proposerData.InsuredDetail.map((item, index) => {
      let newAge = calculateAge(item.dateOfbirth);

      item.InsuredAge = newAge;

      return item;
    });

    localStorage.setItem("InsuredDetail", JSON.stringify(newInsuredDetail));

    let payVal = {
      ...proposerData,
      InsuredDetail: newInsuredDetail,
    };

    setProposerData((prevData) => ({
      ...prevData,
      InsuredDetail: newInsuredDetail,
    }));

    settingData(payVal);

    nav(
      "/" +
        "medicaldetails" +
        "?req_id=" +
        unique_id +
        "&c_id=" +
        c_id +
        "&plan_id=" +
        plan_id
    );
  };

  const viewPlan = async () => {
    let newInsuredDetail = proposerData.InsuredDetail.map((item, index) => {
      let newAge = calculateAge(item.dateOfbirth);

      item.InsuredAge = newAge;

      return item;
    });

    localStorage.setItem("InsuredDetail", JSON.stringify(newInsuredDetail));

    let payVal = {
      ...proposerData,
      InsuredDetail: newInsuredDetail,
    };

    setProposerData((prevData) => ({
      ...prevData,
      InsuredDetail: newInsuredDetail,
    }));

    settingData(payVal);

    nav(`/plans?req_id=${unique_id}`);
  };

  useEffect(() => {
    premiumChange();
  }, []);
  useEffect(() => {
    let datacheck = socketManager.isConnected();

    if (datacheck) {
      socketManager.subscribe("message", async (data) => {
        const { company_name, plan_code, emit_data } = data;
        console.log(
          "----------------------called subscriber------------------"
        );

        let emitval;

        if (emit_data && apiResponse.request) {
          if (emit_data[c_id]) {
            emitval = emit_data[c_id][0];

            setNewPremium(emitval.premiumBreakup.totalPremium);

            setApiResponse({
              request: apiResponse.request,
              response: emitval,
            });

            if (previousPremium == emitval.premiumBreakup.totalPremium) {
              submitAccept();

              return;
            }
            setIsLoading(false);
            setAppear(true);
          }
        } else {
          return;
        }
      });
    }
  }, []);

  return (
    <>
      {isLoading && <Loader />}

      <div className={appear ? "modal-wrapper" : "appear-none"}>
        <div className={`overlay ${isActive ? "active" : ""}`}></div>
        <div
          className={`slideInComponent ${isActive ? "active" : ""} ${
            isClosing ? "closing" : ""
          }`}
        >
          <div className="ageupper">
            <h3>Premium Revised</h3>
          </div>

          <div className="agecontext">
            <p className="contextwarning">
              Please Note: - Based on the birth date entered your premium has
              been revised.
            </p>

            <div className="d-flex align-items-center">
              <img
                style={{ width: "80px" }}
                src={apiResponse?.response?.insurerLogo}
                alt="Insurer Logo"
              />
            </div>

            {ageDifference.map((ageItem, index) => {
              return (
                <div className="age-member-details" key={index}>
                  <p className="age-membername">
                    Member - {ageItem.item.InsuredName}
                  </p>
                  <div className="age-difference-details">
                    <div className="agedetails-flex">
                      <p>Previous age</p>
                      <h3>
                        <s>
                          {ageItem.item.InsuredAge === 0
                            ? "< 91 or 91 Days"
                            : `${ageItem.item.InsuredAge} Years`}
                        </s>
                      </h3>
                    </div>
                    <div
                      className="agedetails-flex"
                      style={{ marginRight: "28px" }}
                    >
                      <p>As per date of birth</p>
                      <h3>
                        {calculateAge(ageItem.item.dateOfbirth) === 0
                          ? "< 91 or 91 Days"
                          : `${calculateAge(ageItem.item.dateOfbirth)} Years`}
                      </h3>
                    </div>
                  </div>
                </div>
              );
            })}

            {ageSame.map((ageItem, index) => {
              return (
                <div className="age-member-details" key={index}>
                  <p className="age-membername">
                    Member - {ageItem.InsuredName}
                  </p>
                  <div className="age-difference-details">
                    <div className="agedetails-flex">
                      <p>Current age</p>

                      <h3>
                        {calculateAge(ageItem.dateOfbirth) === 0
                          ? "< 91 or 91 Days"
                          : `${calculateAge(ageItem.dateOfbirth)} Years`}
                      </h3>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>

          <div className="age-premium-details">
            <div className="age-premium-inner">
              <p>Old Premium</p>
              <span>
                <s>{previousPremium}/-</s>
              </span>
            </div>

            <div className="age-premium-inner agerightside">
              <p>Revised Premium</p>
              <span>
                <b>{newPremium}/-</b>
              </span>
            </div>
          </div>
          <div className="age-premium-footer">
            <div className="age-premium-change">
              <div className="age-footer-upper">
                <p className="totalprimuim"> Total Premium </p>
                <div className="age-footer-premium-detail">
                  <p className="age-old-premium"></p>
                  {newPremium ? (
                    <p className="age-new-premium">{newPremium}/-</p>
                  ) : (
                    <Loader />
                  )}
                </div>
              </div>

              <div className="age-footer-btn">
                <button
                  onClick={() => {
                    submitAccept();
                  }}
                  className="acceptplane"
                >
                  Accept & continue
                </button>
                <button
                  onClick={() => {
                    viewPlan();
                  }}
                  className="acceptplane"
                >
                  View other plans
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AgeModal;
